import { FC } from 'react';

import { IconProps } from '../../shared/ui';

export const SandTherapyIcon: FC<IconProps> = ({ width = 48, height = 48, fillBg = '#828282', fill = '#63656A' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="10" fill={fillBg} />

      <g transform="translate(8 8) scale(0.06)">
        <path
          d="M0,357.7227783l247,140v-120l-247-110V357.7227783z
          M512,267.7409973l-247,109.981781v120l247-139.4848328V267.7409973z
          M455.1641846,277.9064636l38.7610168-17.1413269l-85.0889282-32.2471313l-7.8757324,21.2828522C416.487793,256.6708984,435.0108643,266.48703,455.1641846,277.9064636z
          M357.3456116,14.2772093l-16.092926,45.1839714c-3.5722656,12.4966965,2.8353271,31.6537094,23.4079895,35.6736603l-26.8122559,74.8105469c-21.792511-9.1030426-41.2434082-2.8312988-52.9347229,9.8306732l-29.3911591-11.2871399L18.0601406,260.7290649l38.6854248,16.8948059c63.5622597-37.8819122,138.7563324-64.0265045,210.7644806-59.8922424l-10.43573,28.0362244c-27.3458252,0.8110809-50.7308655,7.6781158-71.2333374,18.9524841c71.5344849-11.513092,146.0503845,7.610199,201.1564026,35.9378357c-1.3308411-6.491394-4.9849548-12.3795471-11.0791931-18.2104187l19.4934082-55.2486572c5.8800964-15.7834625,1.237915-45.6482239-35.2806091-51.0641327l26.9246826-74.5845566c25.2302856,6.3505249,40.2459106-10.0839539,43.7929382-20.9614563l14.6986694-41.8628845L357.3456116,14.2772093z
          M407.6009216,74.8909225c-0.7280273,3.0333557-6.0735474,5.5181885-10.3134766,3.6400299l-26.3297119-7.4014206c-5.1257629-2.0163651-7.1122131-5.1521301-5.4601135-9.5854416l6.1880798-17.4722404l42.9526062,12.0121307L407.6009216,74.8909225z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
